import ValueObject from "../../../../../frontend/ValueObject";
import {Pricing} from "./Pricing";

export interface ArrangementProps {
    title: string,
    discount: any,
    sales: null,
    sold_out: boolean,
    alerts: any,
    is_purchasable: boolean,
    is_lmd_for_sale: boolean,
    has_availability: boolean,
    multi_tab_name: string,
    pills?: any[],
    pricing: Pricing,
    second_line: string | null,
    stats: {
        discount: string,
        sales: string
    },
    multi_deal_description: string,
    unique: string
}

export class Arrangement extends ValueObject<ArrangementProps> {
    get title() {
        return this._props.title ?? this._props.multi_deal_description;
    }

    get tab() {
        return this._props.multi_tab_name;
    }

    get pricing(): Pricing {
        return this._props.pricing;
    }

    get secondLine(): string | null {
        return this._props.second_line;
    }

    get stats(): any {
        return this._props.stats;
    }

    get pills(): any {
        return this._props.pills;
    }

    get unique(): any {
        return this._props.unique;
    }

    get isPurchasable() {
        return (this._props.is_purchasable || this._props.is_lmd_for_sale) && this._props.has_availability !== false;
    }

    static create(props: any) {
        return new Arrangement(Object.assign(props, {
                title: props.multi_deal_description ?? props.title,
                pricing: Pricing.create( props.pricing ),
                pills: props.pills?.map((pill: any) => {
                    return pill;
                })
            }
        ));
    }
}
